import React from "react";
import "./App.css";
import { App } from "visual-chat-builder";
import "../node_modules/@cometchat/chat-uikit-react/dist/styles/css-variables.css";
import "../node_modules/visual-chat-builder/dist/index.css";

function VcbPreviewApp() {
  
  return (
    <div className="App">
      <App />
    </div>
  );
}

export default VcbPreviewApp;
